import React, { FC } from 'react'
import { Formik, FormikProps } from 'formik'
import { t } from '@lingui/macro'
import { signupFirstStepValidation } from '../../schemas/signup.schema'
import { SignupFirstStepValues } from 'pages/native/onBoarding/types/types'
import {
  useCompanyName,
  useUserData
} from 'pages/native/onBoarding/context/OnBoardingContext'
import { useHistory } from 'react-router-dom'
import {
  nativePublicPathGenerator,
  NATIVE_PUBLIC_ROUTES
} from 'routes/native/PublicRoutes'
import { SectionHeader } from 'pages/native/onBoarding/components'
import { SignupFirstStepForm } from '../Forms/SignupFirstStepForm/SignupFirstStepForm'
import { useAnalytics } from 'utils/analytics/useAnalytics'

import styles from './SignupFirstStep.module.scss'

interface Props {
  initialValues: SignupFirstStepValues
  onSubmitForm: (values: SignupFirstStepValues) => void
  company?: string
}

export const SignupFirstStep: FC<Props> = ({ initialValues, onSubmitForm }) => {
  const { value: savedUserData, set: setUserData } = useUserData()
  const initialFormValues = { ...initialValues, ...savedUserData }

  const history = useHistory()
  const { value: company } = useCompanyName()
  const { trackGtm, trackClarity } = useAnalytics()

  const onSubmit = (values: SignupFirstStepValues) => {
    setUserData(values)

    trackGtm('step1_user_details_completed_app', {
      gender: values.gender,
      birthYear: values.birthYear,
      phoneEntered: !!values.phone
    })

    trackClarity('step1_user_details_completed_app', {
      gender: values.gender,
      birthYear: values.birthYear,
      phoneEntered: !!values.phone
    })

    onSubmitForm(values)
  }

  return (
    <div className={styles.ContentContainer}>
      <SectionHeader
        title={t`Create your free account.`}
        body={t`Sign up to unlock highlights, track your teams, and personalized your experience.`}
      />

      <Formik
        initialValues={initialFormValues}
        onSubmit={onSubmit}
        enableReinitialize
        validationSchema={signupFirstStepValidation}
        validateOnChange
        validateOnBlur
      >
        {(formik: FormikProps<SignupFirstStepValues>) => (
          <SignupFirstStepForm
            formik={formik}
            onBackToLogin={() =>
              history.push(
                nativePublicPathGenerator(
                  NATIVE_PUBLIC_ROUTES.AUTH.LOGIN,
                  company
                )
              )
            }
          />
        )}
      </Formik>
    </div>
  )
}
